import {Component, Injector, OnInit, OnDestroy} from '@angular/core';
import {ParentModule} from '../../A2-utils/ParentClass/parent-module';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-complaints-resolution',
  templateUrl: './complaints-resolution.component.html',
  styleUrls: ['./complaints-resolution.component.scss']
})
export class ComplaintsResolutionComponent extends ParentModule implements OnInit, OnDestroy {

  openManager = false;
  tripnote: any;
  reload: any;
  private subscriptions: Subscription[] = [];
  public actionsComplaints: string[] = [];
  constructor(
    protected Inject: Injector,
  ) {
    super('complaint', Inject);
    this.subscriptions.push(
      this.$actions.subscribe((data: string[]) => {
        this.actionsComplaints = data;
      }));
  }

  ngOnInit() {
  }

  onOpenManager(event) {
    if (event) {
      this.openManager = true;
      this.tripnote = event;
    }
  }

  onReload(event) {
    this.reload = Math.random();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/complaints/complaints-resolution/complaints-resolution.component.ts